module.exports = __webpack_public_path__ + "img/Logo on background.a17f344d.png";